var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.0008,0,0,50.0008,-138.657,-99.9895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.82,15.969L10.856,15.969C11.149,15.962 11.755,15.71 11.761,15.707C12.779,15.278 14.794,13.954 15.608,13.078L15.657,13.026C15.757,12.92 15.906,12.755 15.941,12.708C16.091,12.501 16.171,12.255 16.171,12C16.171,11.731 16.08,11.466 15.913,11.253C15.886,11.219 15.77,11.093 15.676,10.994L15.597,10.909C14.805,10.064 12.743,8.673 11.66,8.253C11.495,8.188 11.087,8.036 10.864,8.03C10.652,8.027 10.447,8.072 10.251,8.175C10.008,8.307 9.816,8.519 9.714,8.766C9.639,8.942 9.539,9.465 9.538,9.473C9.433,10.052 9.373,10.973 9.375,11.999C9.373,12.969 9.427,13.858 9.522,14.436C9.523,14.442 9.636,15.089 9.754,15.318C9.96,15.716 10.378,15.969 10.82,15.969ZM10.962,9.733C10.97,9.687 10.984,9.619 10.999,9.55C11.053,9.57 11.101,9.588 11.132,9.6C11.999,9.937 13.91,11.225 14.537,11.896L14.626,11.991L14.635,12C14.624,12.01 14.614,12.021 14.605,12.031C14.604,12.033 14.552,12.092 14.547,12.091C13.94,12.747 12.126,13.982 11.2,14.372C11.176,14.382 11.145,14.394 11.112,14.407L11.112,14.407C11.076,14.42 11.038,14.435 11.001,14.45C10.98,14.358 10.961,14.263 10.951,14.201C10.869,13.706 10.821,12.882 10.822,11.999C10.821,11.083 10.875,10.214 10.962,9.733Z",
    style: {
      fill: "white"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPlay);
export default __webpack_public_path__ + "static/media/bigPlay.4af5fa3f.svg";
export { ForwardRef as ReactComponent };